module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/contracheque-inativos/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main